import isNil from 'lodash/isNil';
import {
  NumberLikeFieldTypes,
  TextLikeFieldTypes,
} from '../../../../../constants/fieldsManagementConsts';
import { SfdcDisplayType } from '../../../../../types/fields';

export const isTextLikeFieldType = (type?: SfdcDisplayType) => {
  if (!type) return false;
  return TextLikeFieldTypes.includes(type);
};

export const isNumberLikeFieldType = (type?: SfdcDisplayType) => {
  if (!type) return false;
  return NumberLikeFieldTypes.includes(type);
};

const isValidNumber = (val?: any) => !isNil(val) && Number(val) === val;

const isRegularNumber = (value: string) => {
  const valueAsNumber = Number(value);
  return !isNaN(valueAsNumber);
};

// converting from "form values" to "field"
export const deprecated_formatNumberPropsToField = (
  properties: SweepFieldProperties,
): SweepFieldProperties => {
  const { length, scale } = properties ?? {};
  const formattedProps = { ...properties };

  const isValidNumbers = isValidNumber(length) && isValidNumber(scale);
  if (isValidNumbers) {
    formattedProps.precision = Number(length) + Number(scale); //UI is showing "length" and "scale" - precision is a calculated value
    delete formattedProps.length;
  }
  return formattedProps;
};

export const formatNumberPropsToField = ({ length, scale }: { length: number; scale: number }) => {
  const isValidNumbers = isValidNumber(length) && isValidNumber(scale);
  if (isValidNumbers) {
    return {
      precision: Number(length) + Number(scale),
      scale: Number(scale),
      length: Number(length),
    };
  }
};

// converting from "field" to "form values"
export const formatNumberPropsToValues = (
  properties: SweepFieldProperties,
): SweepFieldProperties => {
  const { scale, precision, defaultValueFormula } = properties ?? {};
  const formattedProps = { ...properties };

  const isValidNumbers = isValidNumber(precision) && isValidNumber(scale);
  if (isValidNumbers) {
    formattedProps.length = Number(precision) - Number(scale); //UI is showing "length" and "scale" (precision is a calculated value)
  }
  if (defaultValueFormula && isRegularNumber(defaultValueFormula)) {
    formattedProps.defaultValue = Number(defaultValueFormula);
    delete formattedProps.defaultValueFormula;
  }
  return formattedProps;
};
